import { Button } from "@/components/ui/button";
import { Clock, Shield } from "lucide-react";

const ageOptions = [
  { label: "10–15 Years", value: "10-15" },
  { label: "15–20 Years", value: "15-20" },
  { label: "20+ Years", value: "20+" },
  { label: "Not Sure", value: "unknown" },
];

interface Props {
  onSelect?: (age: string) => void;
}

export const AdsRoofAgeSelector = ({ onSelect }: Props) => (
  <section className="py-16 bg-muted/30">
    <div className="container mx-auto px-4 max-w-2xl text-center">
      <Clock className="w-10 h-10 text-primary mx-auto mb-4" />
      <h2 className="text-2xl md:text-3xl font-extrabold text-foreground mb-3">
        How Old Is Your Roof?
      </h2>
      <p className="text-muted-foreground mb-8">
        Select your roof's age to see if you qualify for our replacement program.
      </p>
      <div className="grid grid-cols-2 gap-3 max-w-md mx-auto mb-8">
        {ageOptions.map(({ label, value }) => (
          <Button
            key={value}
            variant="outline"
            className="h-14 text-base font-semibold border-2 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all"
            onClick={() => onSelect?.(value)}
          >
            {label}
          </Button>
        ))}
      </div>
      <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
        <Shield className="w-4 h-4 text-primary" />
        <span>Senior & Military discounts available</span>
      </div>
    </div>
  </section>
);
